import { useQuery } from '@apollo/client';

import { GET_PAGE_BY_URL } from '~/graphql/pages';
import { Query, QueryGetPageByUrlArgs } from '~/types';

const useCustomBlocks = (pathname, options?) => {
  const { data: pageData, loading: pageDataLoading } = useQuery<
    Pick<Query, 'getPageByUrl'>,
    QueryGetPageByUrlArgs
  >(GET_PAGE_BY_URL, {
    variables: {
      input: {
        url: [pathname],
      },
    },
    errorPolicy: 'all',
    ...options,
  });

  const page = pageData?.getPageByUrl;
  //filter seo-block to prevent conflicts with page SEO
  const blocks = page?.blocks ? page.blocks.filter((item) => item?.type !== 'seo-block') : [];

  return {
    blocks,
    blocksLoading: pageDataLoading,
  };
};

export default useCustomBlocks;
